import dynamic from 'next/dynamic';
import appConfig from 'app-config';
import withWebClientValidation from 'src/components/HOC/withWebClientValidation';
const AzarMatch = dynamic(() => import('src/components/AzarOnly/Match'), {
  ssr: false
});
const VividiMatch = dynamic(() => import('src/components/VividiOnly/Match'), {
  ssr: false
});
const MatchView = () => {
  switch (appConfig.serviceCode) {
    case 'vividi':
      return <VividiMatch />;
    case 'azar':
    default:
      return <AzarMatch />;
  }
};
export default withWebClientValidation(MatchView);